$(document).ready(function() {

    // --------------------------------------------------------------
    // Date Picker for scholar of the week
    flatpickr(".flatpickr-sundays", {
        dateFormat: "m/d/Y",
        "disable": [
            function(date) {
                // return true to disable
                return (date.getDay() >= 1 );

            }
        ],
    });
    flatpickr(".flatpickr-allDates", {
        dateFormat: "m/d/Y",

    });
    flatpickr(".flatpickr-timePicker", {
        enableTime: true,
        noCalendar: true,
        dateFormat: "h:i K",
    });

    // --------------------------------------------------------------
    // energy house interactions

    // close button on house detail boxes
    $( ".house-wrap .detail-close" ).click(function() {
        $('.detail-box').slideUp("fast");
    });

    $( ".btn-bolt" ).click(function(event) {
        event.preventDefault();

        var thisID = $(this).attr('id'),
            findThis = thisID.split('bolt'),
            theDetails = findThis[1]; // The map regions and detail boxes are associated by ID number

        // closes all detail boxes
        $('.detail-box').slideUp("fast");

        if( $('#e' + theDetails + '').css('display') == 'none') {
            if ($(window).width() > 767) {
                vCenterOrigin($(".house-wrap .detail-box"));
            }
            // opens related details box
            $('#e' + theDetails + '').slideDown("fast");
        }
    });

    $( ".room" ).click(function() {
        // closes all detail boxes
        $('.detail-box').slideUp("fast");
    });

    // // initializing tab to accordion functionality for energy house
    // $('#energyTabs').tabCollapse({
    //     accordionClass: 'visible-xs tab-collapse'
    // });

    // --------------------------------------------------------------
    // map interactions

    $( ".region" ).click(function() {
        var thisID = $(this).attr('id'),
            findThis = thisID.split('region'),
            theDetails = findThis[1]; // The map regions and detail boxes are associated by ID number

        // remove active class on all regions
        $(".region").attr("class", "region");
        // closes all detail boxes
        $('.detail-box').slideUp("fast");

        if( $('#r' + theDetails + '').css('display') == 'none') {
            if ($(window).width() > 767) {
                vCenterOrigin($(".map-wrap .detail-box"));
            }
            // add active class on region clicked on
            $(this).attr("class", "region active");
            // opens related details box
            $('#r' + theDetails + '').slideDown("fast");
        }
    });

    $( "#states" ).click(function() {
        // remove active class on all regions
        $(".region").attr("class", "region");
        // closes all detail boxes
        $('.detail-box').slideUp("fast");
    });

    // close button on map detail boxes
    $( ".map-wrap .detail-close" ).click(function() {
        $(".region").attr("class", "region");
        $('.detail-box').slideUp("fast");
    });


});

/* ==========================================================================
 function definitions
 ========================================================================== */

var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

$(document).ready(function() {

    $('div.homepage-tile').hover( 
        function() {
            $(this).addClass('flip');
        },
        function () {
            $(this).removeClass('flip');
        }
    );

    $('a.search-icon').click( function(event) {
        event.preventDefault();
        $('.mobile-search').toggle();
    });

    function share_sidebar() {
        var window_top = $(window).scrollTop() ;
        var div_top = $('#sticky-anchor').offset().top;

        if (window_top > div_top + 100) {
            $('.share').addClass('fadeInShare');
        } else {
            $('.share').removeClass('fadeInShare');
        }
    }

    function page_tiles() {

        $(window).resize(function() {
            var $this = $('.tile');

            if ($(window).width() > 752) {
                var tile_width = $this.width();
                var tile_height = tile_width;

                $($this).css({'height': tile_height});
            } else {
                $($this).css({'height': '100%'});
            }
        }).trigger('resize');
    }

    if( !isMobile.any() ){

        function sticky_relocate() {
            var window_top = $(window).scrollTop();
            var footer_top = $("footer").offset().top;
            var div_top = $('#sticky-anchor').offset().top;
            var div_height = $("#sticky").height();
            var content_height = $(".pages .content-wrapper").height();

            $( window ).resize(function() {
              var width = $('.sidebar').width();
              $('#sticky').css({'width': width});
            }).trigger('resize');
            
            var padding = 82;  // tweak here or get from margins etc

            var heightstuff = window_top + div_height;
            var otherstuff = footer_top - padding;
            
            if ( div_height > content_height ) {
                $('#sticky').removeClass('stick');
            } else if (window_top + div_height > footer_top - padding) {
                $('#sticky').css({top: (window_top + div_height - footer_top + 40) * -1})
            } else if (window_top > div_top) {
                $('#sticky').addClass('stick');
                $('#sticky').css({'top': 40});
            } else {
                $('#sticky').removeClass('stick');
            }
        }

        $(function () {
            if ($("body").hasClass("pages")) {
                $(window).scroll(sticky_relocate);
                sticky_relocate();
            }
            if ($("body").hasClass("posts")) {
                $(window).scroll(sticky_relocate);
                sticky_relocate();
                $(window).scroll(share_sidebar);
                share_sidebar();
            }
            page_tiles();
        });

    }

    // add a class to the homepage tiles on IE 10, MSEdge, and IE 11
    if (window.navigator.userAgent.indexOf("MSIE") > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        $(".homepage-tiles").addClass("ie");
    }

});


/* ==========================================================================
 function definitions
 ========================================================================== */

// vertical centering text inside a parent
function vCenter(textBlock) {
    marginOffest = 16;

    textBlock.each(function() {
        wrapHeight = $(this).first().parent().height();
        //console.log("slideHeight = "+slideHeight)
        thisHeight = $(this).outerHeight();
        newMargin = ((wrapHeight  - marginOffest - thisHeight)/2);
        $(this).css({
            'margin-top': newMargin
        });
    });
}

// vertical div centering of position origin point
function vCenterOrigin(theBlock) {
    marginOffest = 16;

    theBlock.each(function() {
        thisHeight = $(this).outerHeight();
        newMargin = ((- thisHeight)/2);
        $(this).css({
            'margin-top': newMargin
        });
    });
}

// resizeTextToParent = function(obj){

//     resizeDown = function(){
//         $(obj).each(function(){

//             var maxSize = 40; //Set max size of your text here
//             var minSize = 12; //Set min size of your text here
//             $(this).css({'font-size': maxSize+'px'});

//             while(maxSize > minSize && $(this).outerHeight() > $(this).parent().height() || $(this).outerWidth() > $(this).parent().width()) {
//                 maxSize--;
//                 $(this).css({'font-size': maxSize+'px'});
//             }
//             // sets text on the front of the tile to the same size as the back
//             $(this).closest('.tile').find('.tile-front .tile-body').css({'font-size': maxSize+'px'});
//         })
//     };

//     resizeDown();
// };

// resizeTitleToSlide = function(obj){

//     resizeDown = function(){
//         $(obj).each(function(){

//             var maxSize = 30; //Set max size of your text here
//             var minSize = 16; //Set min size of your text here
//             $(this).css({'font-size': maxSize+'px'});

//             while(maxSize > minSize && $(this).outerHeight() > ($(this).parent().height() * 0.65) || $(this).outerWidth() > $(this).parent().width()) {
//                 maxSize--;
//                 $(this).css({'font-size': maxSize+'px'});
//             }
//             // sets text on the front of the tile to the same size as the back
//             $(this).closest('.tile').find('.tile-front .tile-body').css({'font-size': maxSize+'px'});
//         })
//     };

//     resizeDown();
// };
